export default __webpack_public_path__ + "static/media/ImageAutomationSuccess.3f574b59.gif";